export default __webpack_public_path__ + "static/media/beauvais-airport.d4a50846.webp";